import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { AuditSchedule } from '@mi-front/core';
import { apiClient } from '../../../../../../../../api';
import { ListingView } from '../../../../../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../../../../../core/reports/types';
import {
  buildSchedulesListFilter,
  SchedulesListFilterValues,
  schedulesListMetadataDefaultValues,
} from '../../schedules-list-filter';
import { SchedulesListSpotForm } from './SchedulesListSpotForm';
import { SchedulesListSpotResult } from './SchedulesListSpotResult';

interface Props {
  readonly station: Station;
}

export type SchedulesSpotListing = ListingType<SchedulesListFilterValues, AuditSchedule>;

export function SchedulesSpotListView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<SchedulesSpotListing>
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        customId: '',
        ...schedulesListMetadataDefaultValues,
        sort: 'datetime desc',
      }}
      queryParamsTransform={{
        customId: {
          serialize: (input: string) => {
            return input.replace(/\s/g, '');
          },
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchSchedules(p.station.slug, {
          page: values.pageIndex,
          filter: buildSchedulesListFilter(values, 'SPOT'),
          contain: 'audio,matches',
        });
      }}
      Form={SchedulesListSpotForm}
      Result={SchedulesListSpotResult}
    />
  );
}
